import { FaInstagram } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import { cn } from "@/lib/utils";
import { trackWhatsAppClickConversion } from "@/utils/analytics";

interface SocialLinksProps {
  className?: string;
  iconSize?: number;
  variant?: "default" | "large" | "footer";
  location?: string;
}

const SocialLinks = ({ 
  className, 
  iconSize = 20, 
  variant = "default",
  location = "unknown"
}: SocialLinksProps) => {
  const variantClasses = {
    default: "text-muted-foreground hover:text-foreground",
    large: "p-3 bg-brand-yellow/10 rounded-full hover:bg-brand-yellow/20 text-brand-black",
    footer: "text-white hover:text-brand-yellow"
  };

  const handleWhatsAppClick = () => {
    trackWhatsAppClickConversion('+905076421214', location);
  };

  return (
    <div className={cn("flex items-center gap-x-4", className)}>
      <a 
        href="https://www.instagram.com/prebitit/" 
        target="_blank" 
        rel="noopener noreferrer"
        className={cn("transition-colors", variantClasses[variant])}
        aria-label="Follow us on Instagram"
      >
        <FaInstagram size={iconSize} />
      </a>
      <a 
        href="https://wa.me/905076421214" 
        target="_blank" 
        rel="noopener noreferrer"
        className={cn("transition-colors", variantClasses[variant])}
        aria-label="Contact us on WhatsApp"
        onClick={handleWhatsAppClick}
      >
        <FaWhatsapp size={iconSize} />
      </a>
    </div>
  );
};

export default SocialLinks;